module.exports = __webpack_public_path__ + "static/media/sidemenu_customers.9e86a5c1.svg";